<!-- Overlay Header -->
<overlay-header [showCloseButton]="true"
    (closeClick)="close()">
    <span translate>New Data Query Wizard</span>
</overlay-header>

<!-- Dialog Content -->
<div style="flex: 1; display: flex; flex-direction: column; overflow: hidden;">

    <!-- Stepper -->
    <mat-horizontal-stepper [selectedIndex]="currentStep"
        (selectionChange)="stepChanged($event)"
        linear>

        <!-- First Step: Query Information -->
        <mat-step label="Area"
            [completed]="queryStepCompleted">
        </mat-step>

        <!-- Second Step: Select Fields -->
        <mat-step label="Fields"
            [completed]="fieldStepCompleted">
        </mat-step>

        <!-- Third Step: Select Filters -->
        <mat-step label="Filters"
            optional="true"></mat-step>

        <!-- Fourth Step: Show Results and Confirm -->
        <mat-step label="Results"></mat-step>
    </mat-horizontal-stepper>

    <!-- Query Info Content -->
    <data-query-wizard-query-info class="stepContent"
        [savedQueries]="savedQueries"
        [simpleValidationErrors]="errors"
        [queryExists]="queryExists"
        *ngIf="currentStep == 0">
        <tyl-button id="leftFooter"
            image="previous arrow.png"
            disabledImage="previous arrow disabled.png"
            label="Previous"
            [disabled]="true"
            (clickEvent)="previousStep()"></tyl-button>
        <tyl-button id="rightFooter"
            image="next arrow.png"
            disabledImage="next arrow disabled.png"
            label="Next"
            [disabled]="!queryStepCompleted"
            (clickEvent)="nextStep()"></tyl-button>
    </data-query-wizard-query-info>

    <!-- Fields Content -->
    <data-query-fields [simpleMode]="true"
        [simpleValidationErrors]="errors"
        class="stepContent"
        *ngIf="currentStep == 1">
        <tyl-button id="leftFooter"
            image="previous arrow.png"
            label="Previous"
            (clickEvent)="previousStep()"></tyl-button>
        <tyl-button id="rightFooter"
            image="next arrow.png"
            disabledImage="next arrow disabled.png"
            label="Next"
            [disabled]="!fieldStepCompleted"
            (clickEvent)="nextStep()"></tyl-button>
    </data-query-fields>

    <!-- Filters Content -->
    <data-query-filters [simpleMode]="true"
        class="stepContent"
        *ngIf="currentStep == 2">
        <tyl-button id="leftFooter"
            image="previous arrow.png"
            label="Previous"
            (clickEvent)="previousStep()"></tyl-button>
        <tyl-button id="rightFooter"
            image="next arrow.png"
            disabledImage="next arrow disabled.png"
            label="Next"
            (clickEvent)="nextStep()"></tyl-button>
    </data-query-filters>

    <!-- Results Content -->
    <data-query-results [simpleMode]="true"
        [simpleValidationErrors]="errors"
        (querySaved)="saveQuery()"
        class="stepContent"
        *ngIf="currentStep == 3">
        <tyl-button id="leftFooter"
            image="previous arrow.png"
            label="Previous"
            (click)="previousStep()"></tyl-button>
        <tyl-button id="rightFooter"
            image="next arrow.png"
            disabledImage="next arrow disabled.png"
            label="Next"
            [disabled]="true"
            (click)="nextStep()"></tyl-button>
    </data-query-results>
</div>